<div class="container-fluid">

 <h4 class="card-title mt-5 mb-5  text-center">{{title}}</h4>
<div class="text-center"><button type="button" (click)="dialogRef.close(true)" class="btn  mb-3 mr-3 btn-gradient-primary btn-rounded btn-fw">Так</button>
<button  type="button" (click)="dialogRef.close(false)" class=" mb-3 mr-3 btn btn-gradient-secondary btn-rounded btn-fw">Ні</button></div>
</div>
